import { render, staticRenderFns } from "./navbarProfile.vue?vue&type=template&id=79fe4821&scoped=true"
import script from "./navbarProfile.vue?vue&type=script&lang=js"
export * from "./navbarProfile.vue?vue&type=script&lang=js"
import style0 from "./navbarProfile.vue?vue&type=style&index=0&id=79fe4821&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fe4821",
  null
  
)

export default component.exports